import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getGroupOrderParticipantCount } from '@/services/order/order-helper';
import defer from 'lodash/defer';

@Component({
  name: 'CmgManageGroupOrderBanner',
})
export default class CmgManageGroupOrderBanner extends Vue {
  get participantMealCount(): number {
    const order = this.$services.order.getCurrentOrder();
    return order && order.order.meals ? getGroupOrderParticipantCount(order.order.meals) : 0;
  }

  openBag(event: any): void {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.bag.setBagVisibility(true);
    const fullmodalExist = document.querySelectorAll('.fullModal').length;
    this.$services.ui.focusDiv('.fullModal');
  }
}
